/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import React from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import ValidatorNumberField from "../../../Validator/ValidatorNumberField";
import { SpecialFinancialBurden } from "../../../../types/ProcessCostSupport";
import { UseForm } from "../../../../types/UseForm";

type SpecialBurdenProps = {
  path: string;
  specialBurden: SpecialFinancialBurden;
  handleChange: UseForm["handleChange"];
};

const SpecialBurden = ({ path, specialBurden, handleChange }: SpecialBurdenProps) => {
  return (
    <>
      <Grid
        size={{
          xs: 12,
          md: 6,
          lg: 4
        }}>
        <TextField
          fullWidth={true}
          name={path + ".description"}
          label={"Beschreibung"}
          margin="normal"
          value={specialBurden.description}
          onChange={handleChange}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
          lg: 4
        }}>
        <ValidatorNumberField
          fieldType={"money"}
          numberType={"float"}
          fullWidth={true}
          name={path + ".petitionerShare"}
          label={"Ich zahle davon"}
          margin="normal"
          value={specialBurden.petitionerShare}
          onChange={handleChange}
        />
      </Grid>
    </>
  );
};

export default SpecialBurden;
